import React from "react";

import { Link } from "react-router-dom";
import { routes } from "consts";

import { Tooltip } from "react-tooltip";

import { FaHotel } from "react-icons/fa6";
import { PiNotebookFill } from "react-icons/pi";
import { FaListUl } from "react-icons/fa6";
import { IoMdPricetags } from "react-icons/io";
import { FaCalendarCheck } from "react-icons/fa";
import { PiExamFill } from "react-icons/pi";
import { TbLicense } from "react-icons/tb";
import { MdFormatAlignJustify } from "react-icons/md";
import { FaVideo } from "react-icons/fa6";

import { IconType } from "react-icons";
import { CourseStatusApi } from "api/course-status";

export const CourseFlags = ({
  courseId,
  publicDataReady,
  sessionsReady,
  scheduleReady,
  tranchesReady,
  examsReady,
  documentsReady,
  resourcesReady,
  arePlacesPublic,
  applicationFormReady,
}: { courseId: number } & CourseStatusApi) => {
  const dots = [
    {
      id: `publicDataReady`,
      ready: publicDataReady,
      tooltip: "Dane publiczne",
      icon: PiNotebookFill,
      to: routes.COURSES_EDIT_NESTED.PREVIEW(courseId),
    },
    {
      id: `sessionReady`,
      ready: sessionsReady,
      tooltip: "Zjazdy",
      icon: FaListUl,
      to: routes.COURSES_EDIT_NESTED.SESSION(courseId),
    },
    {
      id: `scheduleReady`,
      ready: scheduleReady,
      tooltip: "Harmonogram",
      icon: FaCalendarCheck,
      to: routes.COURSES_EDIT_NESTED.SCHEDULE(courseId),
    },
    {
      id: `arePlacesPublic`,
      ready: arePlacesPublic,
      tooltip: "Miejsca",
      icon: FaHotel,
      to: routes.COURSES_EDIT_NESTED.SCHEDULE(courseId),
    },
    {
      id: `tranchesReady`,
      ready: tranchesReady,
      tooltip: "Płatności",
      icon: IoMdPricetags,
      to: routes.COURSES_EDIT_NESTED.PAYMENTS(courseId),
    },
    {
      id: `examsReady`,
      ready: examsReady,
      tooltip: "Egzaminy",
      icon: PiExamFill,
      to: routes.COURSES_EDIT_NESTED.EXAMS(courseId),
    },
    {
      id: `documentsReady`,
      ready: documentsReady,
      tooltip: "Dokumenty",
      icon: TbLicense,
      to: routes.COURSE_PAGE.DOCUMENTS(courseId),
    },
    {
      id: `applicationFormReady`,
      ready: applicationFormReady,
      tooltip: "Formularz zgłoszeniowy",
      icon: MdFormatAlignJustify,
      to: routes.COURSES_EDIT_NESTED.FORM(courseId),
    },
    {
      id: `resourcesReady`,
      ready: resourcesReady,
      tooltip: "Materiały",
      icon: FaVideo,
      to: routes.COURSES_MANAGE_NESTED.RESOURCES(courseId),
    },
  ];
  return (
    <div className="flex gap-0.5">
      {dots.map((dot, index) => (
        <FlagSquare key={index} {...dot} />
      ))}
    </div>
  );
};

const FlagSquare = (props: { to: string; id: string; ready: boolean; tooltip: string; icon: IconType }) => {
  return (
    <>
      {" "}
      <Link to={props.to} onClick={(e) => e.stopPropagation()}>
        <props.icon
          id={props.id}
          size={24}
          className={props.ready ? "text-emerald-500 hover:text-emerald-600" : "text-slate-400 hover:text-slate-500"}
        />
        <Tooltip anchorSelect={`#${props.id}`}>{props.tooltip}</Tooltip>
      </Link>
    </>
  );
};
